import { getCurrency } from 'data/Currencies/selectors'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'

type OwnProps = { code: string }
type Props = OwnProps & ConnectedProps<typeof connector>

const Currency = ({ code, currencyData }: Props) => <>{currencyData?.displaySymbol ?? code}</>

const mapStateToProps = (state, { code }: OwnProps) => ({
  currencyData: getCurrency(state, code)
})
const connector = connect(mapStateToProps)
export default connector(Currency)
